/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbSharedRefineMenuFilterLocation_viewer = {
    readonly locations?: {
        readonly edges: ReadonlyArray<{
            readonly node: {
                readonly count: number | null;
                readonly displayName: string | null;
                readonly urlLabel: string | null;
                readonly linkReference: string | null;
            } | null;
        } | null> | null;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRefineMenuRadioSelectSearch_viewer">;
    readonly " $refType": "SbSharedRefineMenuFilterLocation_viewer";
};
export type SbSharedRefineMenuFilterLocation_viewer$data = SbSharedRefineMenuFilterLocation_viewer;
export type SbSharedRefineMenuFilterLocation_viewer$key = {
    readonly " $data"?: SbSharedRefineMenuFilterLocation_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRefineMenuFilterLocation_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbSharedRefineMenuFilterLocation_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "uriRef",
      "type": "String"
    },
    {
      "kind": "RootArgument",
      "name": "userZipCode",
      "type": "String"
    },
    {
      "kind": "RootArgument",
      "name": "userCountryCode",
      "type": "String"
    },
    {
      "kind": "RootArgument",
      "name": "isClient",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuRadioSelectSearch_viewer",
      "args": null
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "isClient",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": "locations",
          "name": "itemFacetSearch",
          "storageKey": null,
          "args": [
            {
              "kind": "Variable",
              "name": "countryCode",
              "variableName": "userCountryCode"
            },
            {
              "kind": "Literal",
              "name": "facetLimit",
              "value": 10
            },
            {
              "kind": "Literal",
              "name": "facetName",
              "value": "location"
            },
            {
              "kind": "Variable",
              "name": "uriRef",
              "variableName": "uriRef"
            },
            {
              "kind": "Variable",
              "name": "zipCode",
              "variableName": "userZipCode"
            }
          ],
          "concreteType": "ItemFacetsQueryConnection",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "ItemFacetsQueryEdge",
              "plural": true,
              "selections": [
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "node",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "FilterValueType",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "count",
                      "args": null,
                      "storageKey": null
                    },
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "displayName",
                      "args": null,
                      "storageKey": null
                    },
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "urlLabel",
                      "args": null,
                      "storageKey": null
                    },
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "linkReference",
                      "args": null,
                      "storageKey": null
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
(node as any).hash = '42cd381fbe623e23c298bb8ae1bd86ac';
export default node;
